var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 25C19.9614 25 25.334 19.6274 25.334 13C25.334 6.37258 19.9614 1 13.334 1C6.70657 1 1.33398 6.37258 1.33398 13C1.33398 19.6274 6.70657 25 13.334 25Z",
    stroke: "#ADBEEB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34255 19.0133C7.41102 18.7502 7.46237 18.5309 7.52228 18.3028C7.71913 17.5836 7.91599 16.8643 8.09572 16.1363C8.1214 16.031 8.11284 15.8819 8.06149 15.7854C6.27268 12.2944 8.1214 8.06654 11.8702 7.16308C15.2766 6.34733 18.3407 8.69809 18.897 11.847C19.479 15.1363 17.3821 18.259 14.1982 18.8291C12.9315 19.0572 11.7247 18.8642 10.5692 18.2853C10.4665 18.2327 10.321 18.2151 10.2098 18.2414C8.66917 18.6362 7.65066 18.9344 7.33398 18.9958L7.34255 19.0133ZM8.69485 17.645C9.27685 17.4871 9.8075 17.3555 10.3381 17.1976C10.4836 17.1538 10.6035 17.1801 10.7319 17.259C11.7332 17.8467 12.8031 18.066 13.95 17.8818C16.5861 17.452 18.392 14.9171 17.9898 12.2242C17.5704 9.43489 15.0198 7.5578 12.3238 8.06654C9.06288 8.68054 7.32543 12.4084 8.95161 15.3644C9.13134 15.6889 9.1827 15.9609 9.06288 16.3117C8.91738 16.7328 8.83178 17.1713 8.7034 17.645H8.69485Z",
    fill: "#1D3679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7225 15.8295C13.558 15.7852 11.7104 14.865 10.4496 12.6442C10.003 11.8567 10.0643 10.9542 10.721 10.3349C10.9399 10.1225 11.2201 10.1756 11.4828 10.2199C11.5441 10.2287 11.6141 10.326 11.6491 10.4057C11.8155 10.795 11.9819 11.1843 12.1307 11.5824C12.2095 11.7948 12.0694 11.9895 11.763 12.3345C11.6667 12.4407 11.6491 12.5469 11.7192 12.6796C12.2095 13.5113 12.8837 14.113 13.7856 14.4669C13.917 14.52 14.0133 14.4846 14.1008 14.3784C14.5737 13.7944 14.6262 13.6263 14.8714 13.7413C16.071 14.3253 16.1673 14.343 16.1673 14.4846C16.2111 15.5109 15.2829 15.8737 14.7138 15.8295H14.7225Z",
    fill: "#1D3679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappMedium);
export default __webpack_public_path__ + "static/media/whatsappMedium.1d1142f970a19927eaa58a6008b597e6.svg";
export { ForwardRef as ReactComponent };